/* eslint-disable no-undef */

import gsap from "gsap";
// get other plugins:
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function homeGsap() {
  // do stuff here.

  // fade1
  // // fade each one in successively (in a staggered fashion) EXCEPT the first one (because it's already visible)
  // tl.to(images.slice(1), {
  //   delay: stayDuration,
  //   autoAlpha: 1,
  //   duration: fadeDuration,
  //   stagger: stayDuration + fadeDuration,
  // })
  //   // hide each one after the next one finishes fading in on top of it. Exclude the final image because we'll handle the crossfade with the first image with a tween at the end.
  //   .to(
  //     images.slice(0, images.length - 1),
  //     {
  //       autoAlpha: 0,
  //       duration: 0.01,
  //       stagger: stayDuration + fadeDuration,
  //     },
  //     stayDuration + fadeDuration
  //   )
  //   // show the first image (but it won't be visible yet because the last image is on top of it)
  //   .set(images[0], {
  //     autoAlpha: 1,
  //   })
  //   // now fade out the last image so that the first one is showing again
  //   .to(
  //     images[images.length - 1],
  //     {
  //       autoAlpha: 0,
  //       duration: fadeDuration,
  //     },
  //     "+=" + stayDuration
  //   );

  //
  //
  // fade2
  gsap.set(".p-fv__kv-image:not(.p-fv__kv-image--active)", {
    opacity: 0,
  });

  function crossFade() {
    const activeImg = document.querySelector(".p-fv__kv-image.p-fv__kv-image--active");
    const nextImg = activeImg.nextElementSibling || document.querySelector(".p-fv__kv-image:first-child");

    gsap.to(activeImg, {
      duration: 4,
      opacity: 0,
    });
    gsap.to(nextImg, {
      duration: 4,
      opacity: 1,
      onStart: setActive,
    });

    function setActive() {
      activeImg.classList.remove("p-fv__kv-image--active");
      nextImg.classList.add("p-fv__kv-image--active");
    }
  }
  setInterval(crossFade, 8000);

  // //fade
  // gsap.set(".p-fv__kv-image", {
  //   autoAlpha: 0,
  //   scale: 1,
  // });
  // var imgs = gsap.utils.toArray(".p-fv__kv-image");
  // var next = 4; // time to change
  // var fade = 3; // fade time

  // //only for the first
  // gsap.set(imgs[0], { autoAlpha: 1 });

  // function crossfade() {
  //   var kvTl = gsap.timeline();

  //   kvTl
  //     .to(imgs[0], {
  //       autoAlpha: 0,
  //       duration: fade,
  //     })
  //     .to(
  //       imgs[1],
  //       {
  //         autoAlpha: 1,
  //         duration: fade,
  //       },
  //       0
  //     );

  //   imgs.push(imgs.shift());

  //   // start endless run
  //   gsap.delayedCall(next, crossfade);
  // }

  // // start the crossfade after next = 3 sec
  // gsap.delayedCall(next, crossfade);

  // gsap.fromTo(
  //   ".p-fv__kv",
  //   {
  //     autoAlpha: 0,
  //   },
  //   {
  //     autoAlpha: 1,
  //     delay: 0,
  //     ease: "power1.inOut",
  //   }
  // );

  gsap.fromTo(
    ".js-fv-brand-slogan",
    {
      autoAlpha: 0,
      y: 0,
    },
    {
      autoAlpha: 1,
      y: -10,
      duration: 1,
      delay: 1,
      ease: "power1.inOut",
    }
  );

  gsap.fromTo(
    ".js-fv-brand-slogan-decoration",
    {
      autoAlpha: 0,
      y: 0,
    },
    {
      autoAlpha: 1,
      y: -10,
      duration: 1,
      delay: 2,
      ease: "power1.inOut",
    }
  );
}
